/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/jsx-curly-newline */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';

// components
import { Grid, Input, InputPhone, Button } from '@design-system-coopeuch/web';
import AddressInput from '../../atoms/AddressInput/AddressInput';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';
import Modal from '../../organisms/Modal/Modal';

import { useModal } from '../../../hooks/useModal';
import { coverageActions } from '../../../../application/actions/coverage';

// constants
import { constants } from '../../../../domain/constants/index';
// styles
import { StyledWrapperInput } from '../../../assets/styles/styles';

// assets
import iconMap from '../../../assets/img/icon-map.svg';

const MAX_EMAIL_LENGTH = constants.MAX_EMAIL_LENGTH
const MAX_PHONE_LENGTH = constants.MAX_PHONE_LENGTH
const MAX_ANOTHER_DATA = constants.MAX_ANOTHER_DATA

const CardContactData = (props) => {
  const { phone, /* onChangeAddress */ confirmationPhone, email, address, disabled, onChange, onShareDirection, coverageData } = props;
  const { coverage } = coverageData

  const dispatch = useDispatch()
  const [isOpen, openModal, closeModal] = useModal(false);
  const [localAnotherData, setLocalAnotherData] = useState(address.anotherData || '');
  /* istanbul ignore next */
  const handleOpenModal = () => {
    openModal();
  };
  /* istanbul ignore next */
  const handleCloseModal = () => {
    closeModal();
  }

  const handleAddressData = (addressReceived) => {
    onChange({
      field: 'address',
      property: 'value',
      value: { ...address.value, ...addressReceived }
    })
  }

  const handleAnotherData = (value) => {
    setLocalAnotherData(value);
    onChange({
      field: 'address',
      property: 'anotherData',
      value,
    });
  };

  const shareDirection = `${address.value.street || ''} ${address.value.numeration || ''}, ${address.value.commune || ''
    }, ${address.value.country || ''}`.trim();

  // Monitorear cambios en `address` y compartir dirección con el padre
  useEffect(() => {
    if (address.value.street && address.value.numeration && address.value.commune && address.value.country) {
      onShareDirection(shareDirection);
    }
  }, [address, shareDirection, onShareDirection]);

  useEffect(() => {
    if (coverage?.value === false && coverage?.code !== '1') {
      dispatch(coverageActions.validateStatusCoverage({ statusNumber: 1 }))
    }
  }, [coverage])

  return (
    <>
      <SimpleCard
        contentHeader={
          <article className="d-flex flex-column">
            <p className="simplecard__title">Datos de contacto</p>
            <p className="simplecard__subtitle">
              Revisa tus datos: allí te enviaremos una copia de tus contratos
            </p>
          </article>
        }
        disabled={disabled}
      >
        <>
          <Grid row className="m-0 padding-16 p-md-6 border-bottom border-neutral-20">
            <Grid className="p-0 pr-md-4 mb-2" col={12} md={4}>
              <StyledWrapperInput>
                <Input
                  label="Email"
                  value={email.value}
                  maxLength={MAX_EMAIL_LENGTH}
                  assistText={
                    email.errors.length > 0
                      ? email.errors
                      : [{ text: 'Revisa que tu correo esté correcto', type: 'assist' }]
                  }
                  onChange={(value) =>
                    onChange({
                      field: 'email',
                      property: 'value',
                      value,
                    })
                  }
                  error={email.errors.length > 0}
                  autoComplete="new-password"
                />
              </StyledWrapperInput>
            </Grid>
            <Grid className="p-0 pr-md-4 mb-2" col={12} md={4}>
              <StyledWrapperInput>
                <InputPhone
                  label="Número de celular"
                  value={phone.value}
                  maxLength={MAX_PHONE_LENGTH}
                  assistText={phone.errors}
                  onChange={(value) =>
                    onChange({
                      field: 'phone',
                      property: 'value',
                      value,
                    })
                  }
                  onCodeChange={() => { }}
                  error={phone.errors.length > 0}
                  autoComplete="new-password"
                />
              </StyledWrapperInput>
            </Grid>
            <Grid className="p-0 mb-2" col={12} md={4}>
              <StyledWrapperInput>
                <InputPhone
                  label="Confirma tu celular"
                  value={confirmationPhone.value}
                  maxLength={MAX_PHONE_LENGTH}
                  assistText={confirmationPhone.errors}
                  onChange={(value) =>
                    onChange({
                      field: 'confirmationPhone',
                      property: 'value',
                      value,
                    })
                  }
                  onCodeChange={() => { }}
                  error={confirmationPhone.errors.length > 0}
                  autoComplete="new-password"
                />
              </StyledWrapperInput>
            </Grid>
          </Grid>
          <Grid row className="m-0 padding-16 p-md-6">
            <Grid className="p-0 mb-2" col={12}>
              <p className="font-size-18 line-height-30 font-weight-500">Domicilio</p>
              <p className="text-content">
                {`Ingresa tu dirección particular. Asegúrate de incluir el número en la casilla de
                "Dirección".`}
              </p>
            </Grid>
            <Grid row className="m-0 p-0 pt-4 align-items-center" col={12}>
              <Grid className="p-0 mb-2 mb-md-2" col={12} md={8}>
                <AddressInput
                  label="Dirección (con calle y número)"
                  addressObject={address.value}
                  onChange={(addressReceived) => handleAddressData(addressReceived)}
                  onDoSomething={handleOpenModal}
                  coverage={coverage}
                  id={1}
                />
              </Grid>
              <Grid className="p-0 px-md-2 mb-2" col={12} md={4}>
                <StyledWrapperInput>
                  <Input
                    value={
                      localAnotherData
                    }
                    label="Depto/Block/Parcela/Otro"
                    maxLength={MAX_ANOTHER_DATA}
                    placeholder="Ejemplo: Parcela 6"
                    assistText="Opcional"
                    onChange={(value) => handleAnotherData(value)}
                    allowSpaces
                    autoComplete="new-password"
                  />
                </StyledWrapperInput>
              </Grid>
            </Grid>
          </Grid>
        </>
      </SimpleCard>
      <Modal
        isOpen={isOpen}
        closeModal={handleCloseModal}
        closeClickOutside
        closeEscKey
        className={classNames('modal-address-imput')}
      >
        <Grid row className="d-flex flex-column justify-content-center align-items-center">
          <Grid
            col={12}
            md={8}
            className="p-5 d-flex flex-column justify-content-center align-items-center"
          >
            <img src={iconMap} alt="" width="140" className="mt-3" />
            <p className="text-center mt-2 mb-3 font-size-18 font-weight-500">
              Recuerda ingresar calle con número y selecciona una opción de la lista.
            </p>
            <article>
              <p className="text-center mb-3">Ejemplo: Agustinas 1141, Santiago</p>
              <p className="text-center line-height-20">
                Si no encuentras tu dirección en la lista, contácatanos al 600 200 1200.
              </p>
            </article>
          </Grid>
        </Grid>
        <Grid className="p-5 border-top border-neutral-alfa-15 d-flex justify-content-center align-items-center">
          <Button
            disabled={false}
            onClick={handleCloseModal}
            color="secondary"
            className="text-align-center"
            variant="default"
          >
            Entendido
          </Button>
        </Grid>
      </Modal>
    </>
  );
};
/* istanbul ignore next */
CardContactData.defaultProps = {
  phone: { value: '', isValid: () => { }, errors: [] },
  confirmationPhone: { value: '', isValid: () => { }, errors: [] },
  email: { value: '', isValid: () => { }, errors: [] },
  address: {
    value: {
      street: '',
      numeration: '',
      commune: '',
      country: '',
      latitude: 0,
      longitude: 0,
    },
    anotherData: '',
    isValid: () => { },
    errors: [],
  },
  disabled: false,
  onChange: () => null,
  onShareDirection: () => null,
  coverageSaga: { value: '', code: null }
};

CardContactData.propTypes = {
  phone: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  confirmationPhone: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  email: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  address: PropTypes.shape({
    value: PropTypes.exact({
      street: PropTypes.string,
      numeration: PropTypes.string,
      commune: PropTypes.string,
      country: PropTypes.string,
      latitude: PropTypes.number,
      longitude: PropTypes.number,
    }),
    anotherData: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onShareDirection: PropTypes.func,
  coverageSaga: PropTypes.shape({
    value: PropTypes.string,
    code: PropTypes.any
  })
};

export default CardContactData;
